var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0.25C5.41421 0.25 5.75 0.585786 5.75 1V2.25H10.25V1C10.25 0.585786 10.5858 0.25 11 0.25C11.4142 0.25 11.75 0.585786 11.75 1V2.25H13.5C14.7426 2.25 15.75 3.25736 15.75 4.5V13.5C15.75 14.7426 14.7426 15.75 13.5 15.75H2.5C1.25736 15.75 0.25 14.7426 0.25 13.5V4.5C0.25 3.25736 1.25736 2.25 2.5 2.25H4.25V1C4.25 0.585786 4.58579 0.25 5 0.25ZM10.25 3.75V4.5C10.25 4.91421 10.5858 5.25 11 5.25C11.4142 5.25 11.75 4.91421 11.75 4.5V3.75H13.5C13.9142 3.75 14.25 4.08579 14.25 4.5V6.25L1.75 6.25V4.5C1.75 4.08579 2.08579 3.75 2.5 3.75H4.25V4.5C4.25 4.91421 4.58579 5.25 5 5.25C5.41421 5.25 5.75 4.91421 5.75 4.5V3.75H10.25ZM1.75 7.75V13.5C1.75 13.9142 2.08579 14.25 2.5 14.25H13.5C13.9142 14.25 14.25 13.9142 14.25 13.5V7.75L1.75 7.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCalendar);
export default __webpack_public_path__ + "static/media/ico_calendar.3b0140e5eb48e188cd5fdb8a06c4b46e.svg";
export { ForwardRef as ReactComponent };